import React, { Fragment, useContext, useState } from "react";
import { Alert, Box, IconButton, Link, Tooltip, Typography } from "@mui/material";
import { format } from "date-fns";
import { ExpandCircleDown,EnergySavingsLeaf } from "@mui/icons-material";
import { EscalatorWarning, LocalTaxi, Savings } from "@material-ui/icons";

import { converToMiles, getComponentsFromUtcDate, getPassengerFromStb } from "../../../../../contexts/BookingUtilities";
import { BrandContext } from "../../../../../contexts/BrandContext";
import { LoadingBox } from "../../../UniversalComponents";
import { PointContext } from "../../../../../contexts/PointContext";
import { cWarn } from "../../../CustomLogger";
import InfoPopper from "../../../InfoPopper";



export default function FulfilledTaxi(){

    const brandContext = useContext(BrandContext);
    const {
        textContent:{
            openToSharing='',
            notSharing='',
            shareCodeLabel='',
            taxiBookingDetailDialogueTitle='',
            milesUnit='',
            luggageLabel='',
            additionalNotesLabel='',
            pickupTimeLabel='',
            at='',
            taxiRefLabel='',
            fpSupplierLabel='',
            taxiDataErrorMsg='',
            timeDistanceLabel='',
            travelTimeLabel='',
            clientSavingLabel='',
            co2Unit='',
            fareStatusLabel='',
            helpPricePerStudent='',
            helpFareSavingCO2='',
            taxiCoRefLabel='',
            driverLabel='',
            vehicleLabel='',
            vehicleRegLabel='',
        },
        textContent,
        brand:{
            schoolConfig
        }
    } = brandContext;

   const pointContext = useContext(PointContext)

    let taxiFareQuotes = false;
    if(schoolConfig){
        ({taxiFareQuotes} = schoolConfig);
    }
    
    

    let showFares = false;
    const allAvailableFares = [2,3,4];

    const fareIconMap = {
        netMarkup:<LocalTaxi/>,
        umFee:<EscalatorWarning/>,
        walkToCheckIn:<EscalatorWarning/>
    }

    
    const {
        point:{
            transportData
        },
        booking,
        booking:{
            parentApprovedDate:bookingApproved
        },
        index,
        taxiData = null,
        error=false
    } = pointContext;

    const {
        luggage=0,
        shareTaxi=0,
        description,
        taxiBookingId=null
    } = transportData;

    const InnerDetails = () => {


        try{
            const {
                    fullData:{
                        id:taxiBookingId,
                        legToTaxis,
                        shareCode,
                        taxiBookingJobs=[],
                        driveDistance=0,
                        driveTime=0,
                    },
                    customerFareBreakdown:{
                        clientFacingFares=[],
                        fareStage:{
                            id:fareStageId,
                            name:fareStageLabel
                        }
                    },
                    fromPoints=[],
            } = taxiData;
            

            const clientFacingFaresMap = {};

            if(allAvailableFares.includes(fareStageId) || taxiFareQuotes){
                showFares = true;
            }
            
            
            for(let i=0; i<clientFacingFares.length; i+=1){
                const {
                    fares,
                    passenger:{
                        id:passengerId,
                    },
                    passengerType
                } = clientFacingFares[i];
                const key = `${passengerType}_${passengerId}`;
                clientFacingFaresMap[key] = fares;
            }

            let dateLabel = '';
            let timeLabel = '';
            let fromPointTime = '';
            if(fromPoints.length > 0){
                
                const basePoint = fromPoints[0];
                ({
                    pointTime:fromPointTime
                } = basePoint);

                const{
                    year,
                    month,
                    day,
                    hours,
                    mins

                } = getComponentsFromUtcDate(fromPointTime);

                dateLabel = `${day}/${month}/${year}`;
                const date = new Date(year, month - 1, day);
                dateLabel = format(date, 'do MMM yyyy', { useAdditionalWeekYearTokens: true });
                timeLabel = `${hours}:${mins}`;
            } 

            const passengerList = [];
            for(let i=0; i<legToTaxis.length; i+=1){
                const {
                    bookingLeg:{
                        booking:{
                            studentToBookings = []
                        }
                    }
                } = legToTaxis[i];
                for(let j=0; j<studentToBookings.length; j+=1){
                    passengerList.push(studentToBookings[j]); 
                }
            }
            let fp = null;
            let taxiCompanyName = '';
            let fpTel='';
            let statusName = 'Pending';
            let driverContactNo = '';
            let driverName = '';
            let externalId = '';
            let vehicleDescription = '';
            let vehicleReg = '';
            if(taxiBookingJobs.length > 0){
                for(let i=0; i<taxiBookingJobs.length; i+=1){
                    if(taxiBookingJobs[i].isActive){
                        const taxiBookingJob = taxiBookingJobs[i];
                        ({
                            status:{
                                name:statusName=''
                            },
                            driverContactNo='',
                            driverName='',
                            externalId='',
                            vehicleDescription='',
                            vehicleReg='',
                            fp
                        } = taxiBookingJob);
                        break;
                    }
                }
            }
            if(externalId){
                externalId = externalId.split('-')[externalId.split('-').length-1];        
            }
            if(fp){
                ({
                    companyName:taxiCompanyName,
                    mailTel:fpTel='',
                } = fp);

            }
            
            return (
                <Box>
                    <Box sx={{paddingBottom:'10px'}}>
                        {taxiCompanyName ?
                            <>
                                <Typography variant="smallText" component="h6">{fpSupplierLabel} <Typography className="smallTextBold" component="span">{taxiCompanyName} </Typography></Typography>
                                {externalId && <Typography className="smallTextBold" component="h6">{taxiCoRefLabel} {externalId}</Typography>}
                                {fpTel && <Typography className="smallTextBold" component="h6">{fpTel}</Typography>}
                                {driverName && <Typography variant="smallText" component="h6">{driverLabel} <Typography className="smallTextBold" component="span">{driverName}</Typography></Typography>}
                                {vehicleDescription && <Typography variant="smallText" component="h6">{vehicleLabel} <Typography className="smallTextBold" component="span">{vehicleDescription}</Typography></Typography>}
                                {vehicleReg && <Typography variant="smallText" component="h6">{vehicleRegLabel} <Typography className="smallTextBold" component="span">{vehicleReg}</Typography></Typography>}
                                <Typography variant="smallText" component="h6">{taxiRefLabel} <Typography className="smallTextBold" component="span">{taxiBookingId}</Typography></Typography>
                            </>
                            :
                            <>
                                <Typography variant="smallText" component="h6">{taxiRefLabel} <Typography className="smallTextBold" component="span">{taxiBookingId}</Typography></Typography>
                            </>

                        }
                        <Typography variant="smallText" component="h6">{timeDistanceLabel} <Typography className="smallTextBold" component="span">{convertMinutesToTimeString(driveTime)} {converToMiles(driveDistance)} {milesUnit}</Typography></Typography>
                        {showFares &&
                        <Box sx={{display:'flex', flexDirection: 'row-reverse'}}>
                            <BoxOffSetter><InfoPopper bodyText={textContent[`${fareStageLabel}Help`]}/></BoxOffSetter>
                            <Box>
                                <Typography variant="smallText" component="h6">{fareStatusLabel} <Typography className="smallTextBold" component="span">{textContent[fareStageLabel]}</Typography></Typography>
                            </Box>
                            
                        </Box>
                        }
                    </Box>
                    <hr/>
                    <Box sx={{paddingTop:'10px', paddingBottom:'10px'}}>
                        
                            {legToTaxis.map((ltt,i)=>{
                                        
                                const {
                                    bookingLeg:{
                                        wasGmt=false,
                                        booking:{
                                            studentToBookings = [],
                                        }, 
                                    },
                                } = ltt;
                                
                                return (
                                    <Fragment key={i}>
                                        {studentToBookings.map((stb,j)=>{
                                
                                            const passenger = getPassengerFromStb(stb);
                                            
                                            const {
                                                id,
                                                contacts:{
                                                    firstName='',
                                                    lastName='',
                                                    email='',
                                                    mobile=''
                                                },
                                                type=''
                                            } = passenger;
                                            let schoolHouse = '';
                                            if(type === 'student'){
                                                const {
                                                    passenger:{
                                                        SchoolHouse=null
                                                    }
                                                } = passenger;
                                                if(SchoolHouse){
                                                    ({name:schoolHouse} = SchoolHouse);
                                                }
                                            }
                                            const fareKey = `${type}_${id}`;
                                            let passengerFares = null;
                                            if(fareKey in clientFacingFaresMap){
                                                if(clientFacingFaresMap[fareKey].length > 0){
                                                    passengerFares = clientFacingFaresMap[fareKey];
                                                }
                                            }
                                            let hasSaving = 0;
                                            let hasCo2Saving = 0;
                                            return (
                                               <Fragment key={j}>
                                               <Box  sx={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                                                        <StudentExpander title={`${firstName} ${lastName}`}>
                                                            {schoolHouse !== '' && <Typography component="h6" className="smallerText" >{schoolHouse}</Typography>}
                                                            {email !== '' && <Link href={`mailto:${email}`} className="simpleLink smallerText" sx={{whiteSpace:'nowrap', display:'block'}} >{email}</Link>}
                                                            {mobile !== '' && <Link href={`tel:${mobile}`} className="simpleLink smallerText" sx={{whiteSpace:'nowrap', display:'block'}}>{mobile}</Link>}
                                                            {wasGmt && <Typography component="h6" className="smallerText" >GMT</Typography>}
                                                        </StudentExpander>
                                                        {(passengerFares && showFares) &&
                                                            <Box sx={{paddingTop:'6px'}}>
                                                                {passengerFares.map((fare,k)=>{
                                                                        const {
                                                                            co2Saving=0,
                                                                            fareKey=0,
                                                                            gross=0,
                                                                            saving=0,
                                                                        } = fare;
                                                                        if(saving > 0){
                                                                            hasSaving = saving;
                                                                            hasCo2Saving = co2Saving;
                                                                        }
                                                                        let FareIcon = null;
                                                                        if(fareKey in fareIconMap){
                                                                            FareIcon = fareIconMap[fareKey];
                                                                        }
                                                                        return (
                                                                            <Box key={k} >
                                                                                <Tooltip title={textContent[`taxiFareCustomer_${fareKey}`]}>
                                                                                    <Box className="fareBlock"><Box className="fareIconHolder">{FareIcon}</Box> <Box className="feeAmountHolder">£{fNum(gross)}</Box> {fareKey === 'netMarkup' && <BoxOffSetter><InfoPopper bodyText={helpPricePerStudent}/></BoxOffSetter>}</Box>
                                                                                </Tooltip>
                                                                            </Box>
                                                                        );
                                                                })} 
                                                            </Box>
                                                        }
                                                </Box>
                                                
                                                    {((hasSaving > 0) && showFares) &&
                                                        <Box className="savingsContainer">
                                                            <Box className="savingsLabel smallTextBold">
                                                                <Box className="textHolder">
                                                                    {clientSavingLabel} 
                                                                </Box>
                                                                <Box className="iconHolder">
                                                                    <Savings/>
                                                                </Box>
                                                                £{fNum(hasSaving)} 
                                                                {hasCo2Saving > 0 && 
                                                                    <>
                                                                        <Box className="iconHolder energySaving">
                                                                            <EnergySavingsLeaf/>
                                                                        </Box>
                                                                        <Box className="textHolder energySaving">
                                                                            {fNum(hasCo2Saving)}{co2Unit}
                                                                        </Box>
                                                                    </>
                                                                }
                                                                <BoxOffSetter><InfoPopper bodyText={helpFareSavingCO2}/></BoxOffSetter>
                                                            </Box>
                                                        </Box>
                                                    }
                                                </Fragment>
                                            );
                                        })}
                                    </Fragment>
                                );
                            })}
                        
                    </Box>
                    <hr/>
                    <Box sx={{paddingTop:'10px', paddingBottom:'10px'}}>
                    
                        {shareTaxi === '1' && <Typography component="h6" variant="smallBoldText">{openToSharing}</Typography> }
                        {shareCode && <Typography component="h6" variant="smallText">{shareCodeLabel} { shareCode }</Typography>}
                        {luggage && <Typography variant="smallText" component="h6">{luggageLabel} <Typography className="smallTextBold" component="span">{luggage}</Typography></Typography>}
                    </Box>
                    {description && 
                        <>
                            <hr/>
                            <Box sx={{paddingTop:'10px', paddingBottom:'10px'}}>
                                <Typography component="h6" variant="smallText">
                                    {description}
                                </Typography>
                            </Box>
                        </>
                    }
                </Box>
            );
        }
        catch(e){
            cWarn(e);
            return null;
        }
    }
    



    return (
        <div>
           {!bookingApproved ? 
               <Box>
               {shareTaxi === '1' ? <>{openToSharing}<br/></> : <>{notSharing}<br/></> }
               {luggage && <>{luggageLabel} {luggage}<br/></>}
               {description && <>{additionalNotesLabel} {description}</>}
           </Box>
           :
           <>
           {error ? 
                <Box>
                    <Alert severity="error">{taxiDataErrorMsg}</Alert>
                    {shareTaxi === '1' ? <>{openToSharing}<br/></> : <>{notSharing}<br/></> }
                    {luggage && <>{luggageLabel} {luggage}<br/></>}
                    {description && <>{additionalNotesLabel} {description}</>}
                </Box>
                :
                <>
                {(taxiData || !taxiBookingId) ?
                    <>
                    {taxiData === null ? 
                        <Box>
                           <LoadingBox/>
                        </Box>
                        :
                        <>
                            <InnerDetails/>
                        </>
                    }
                    </>
                    :
                    <LoadingBox/>
                }
                </>
            } 
            </>
            }
           
        </div>
    );


}

const BoxOffSetter = (props) => (<Box className="fareIconHolder" sx={{position:'relative'}}><Box sx={{position:'absolute', right:'-24px', top:0}}>{props.children}</Box></Box>)

const fNum = (stringNumber) => parseFloat(stringNumber).toFixed(2);

const convertMinutesToTimeString = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    const formattedHours = hours; 
    const formattedMinutes = minutes; // Ensure leading zero if needed
  
    return `${formattedHours}h ${formattedMinutes}m`;
  };

  const StudentExpander = (props) => {

    const {
        title=''
    } = props;

    const [open,setOpen] = useState(false);

    const iconStyle = {};
    if(open){
        iconStyle.transform = 'rotate(180deg)'
    }

    return (
        <Box sx={{marginLeft:'-10px'}}>
            <Box sx={{display:'flex', cursor:'pointer'}} onClick={()=>setOpen(!open)}>
                <IconButton size="small">
                    <ExpandCircleDown sx={iconStyle}/>
                </IconButton>
                <Typography component="h6" className="smallerText" sx={{fontWeight:'bold',whiteSpace:'nowrap', lineHeight:'34px'}}>{title}</Typography>
            </Box>
            {open && 
            <Box sx={{ textAlign:'left', paddingLeft:'10px', overflow:'hidden'}}>
                {props.children}
            </Box>
            }
        </Box>
    );
}